import { Modal, Button, styled } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "@/components/Forms/components/ButtonMenu";

const ConfirmationMessage = styled.div`
  margin: 15px 0px;
  min-height: 50px;
`;

interface DeleteCustomFieldProps {
  handleOpen: boolean;
  title?: string;
  handleSubmit: () => void;
  handleClose: () => void;
}

const DeleteCustomField = ({
  handleOpen = false,
  title = "Delete Custom Field",
  handleSubmit,
  handleClose,
}: DeleteCustomFieldProps) => {
  return (
    <Modal open={handleOpen} onClose={handleClose} style={{ width: "500px" }}>
      <Modal.Title>{title}</Modal.Title>
      <ConfirmationMessage>
        Are you sure you want to delete this custom field? This action is
        permanent and will remove all associated data.
      </ConfirmationMessage>
      <ButtonMenu>
        <Button size="xs" variant="subtle" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          size="xs"
          color="error"
          variant="contained"
          onClick={handleSubmit}
        >
          Delete
        </Button>
      </ButtonMenu>
    </Modal>
  );
};

export default DeleteCustomField;
